import { i18n } from '@/main';
import {ChangeDisplayOrderMsgOption, GridProp, OptColumn} from '@/pro/types';
import {getDisplayOrderHistoryColumn} from '@/pro/components/product/common/girdColumns/ChangeHistory';
import {formatCurrency} from '@/pro/utils/numberFormat';
import {i18nForProduct} from '@/pro/utils/i18n';
import {getSpanHTML} from '@/pro/utils/grid/formatterUtils';

export const gridOptions = (): GridProp => ({
  displayOptions: {
    showsRightArea: false,
    pageSizeKey: 'size',
  },
  header: {
    height: 33,
    align: 'center',
  },
  options: {
    rowHeaders: [
      {
        type: 'checkbox',
        header: i18n.t('PRO_PRODUCT_ADD_SELECT').toString(),
      },
    ],
    scrollY: true,
    minBodyHeight: 60,
    bodyHeight: 420,
    rowHeight: 31,
    pageOptions: {
      useClient: true,
      type: 'scroll',
    },
  },
});

// 자동진열: rowNum 추가, displayOrder 삭제
export const autoColumn = (): OptColumn[] => [
  {
    header: 'PRO_PRODUCT_ADD_HEADER_NO',
    name: 'rowNum',
    width: 80,
    align: 'center',
    formatter: ({ row }) => `${row.history ? row.displayOrder : Number(row.rowKey) + 1}`,
  },
];
// 수동진열: displayOrder 추가, rowNum 삭제
export const manualColumn = (): OptColumn[] => [
  getDisplayOrderHistoryColumn('PRO_PRODUCT_ADD_DISPLAY_ORDER', 'displayOrder', 100),
];
export const columns = (): OptColumn[] => [
  // 상품번호
  {
    header: 'PRO_PRODUCT_ADD_PRODUCT_NO',
    name: 'productNo',
    width: 120,
    align: 'center',
  },
  // 상품명
  {
    header: 'PRO_PRODUCT_ADD_PRODUCT_NAME',
    name: 'productName',
    width: 400,
    align: 'center',
  },
  // 즉시할인가
  {
    header: 'PRO_PRODUCT_ADD_IMMEDIATE_DISCOUNT_AMOUNT',
    name: 'immediateDiscountAppliedPrice',
    width: 150,
    align: 'center',
    formatter: ({ value }) => `${formatCurrency(Number(value))}${i18nForProduct('AMOUNT')}`,
  },
  // 판매상태
  {
    header: 'PRO_PRODUCT_ADD_SALE_STATUS_TYPE',
    name: 'saleStatusType',
    width: 150,
    align: 'center',
    formatter: ({ value, row }) => {
      const periodText = row.isPeriodType && value === 'ON_SALE' ? `(${i18nForProduct('SALE_PERIOD')})` : '';
      return `${i18nForProduct(value.toString())}${periodText}`;
    },
  },
  // 판매설정태
  {
    header: 'PRO_PRODUCT_ADD_SALE_SETTING_STATUS_TYPE',
    name: 'saleSettingStatusType',
    width: 150,
    align: 'center',
    formatter: ({ value }) => i18nForProduct(value.toString()),
  },
  // 전시상태
  {
    header: 'PRO_PRODUCT_ADD_DISPLAY_YN',
    name: 'frontDisplayable',
    width: 150,
    align: 'center',
    formatter: ({ value }) => i18nForProduct(value ? 'DISPLAY_Y' : 'DISPLAY_N'),
  },
  // 품절상태
  {
    header: 'PRO_PRODUCT_ADD_SOLD_OUT',
    name: 'isSoldOut',
    width: 150,
    align: 'center',
    formatter: ({ value }) => i18nForProduct(value ? 'N_STOCK' : 'Y_STOCK'),
  },
  {
    header: 'PRO_PRODUCT_ADD_REMOVE',
    name: 'delete',
    width: 100,
    align: 'center',
    formatter: () => getSpanHTML(i18n.t('DELETE').toString()),
  },
];

export const message: ChangeDisplayOrderMsgOption = {
  needOrigin: 'PRO_PRODUCT_ADD_PLZ_SELECT_PRODUCT_TO_MOVE',
  selectedTarget: 'PRO_PRODUCT_ADD_SELECTED_TARGET_MSG',
};
